/**
 * @generated SignedSource<<1df4f489b796cfb34966eebafc473840>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bundleTag"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nbOfFrame"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "version"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bundleTag",
        "variableName": "bundleTag"
      },
      {
        "kind": "Variable",
        "name": "nbOfFrame",
        "variableName": "nbOfFrame"
      },
      {
        "kind": "Variable",
        "name": "offerId",
        "variableName": "offerId"
      },
      {
        "kind": "Variable",
        "name": "version",
        "variableName": "version"
      }
    ],
    "concreteType": "ExternalFrame",
    "kind": "LinkedField",
    "name": "getHistoryFrames",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "metadata",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QGetHistoriesFramesQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "QGetHistoriesFramesQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "0c2981a519b6720aa85737d4ef41da35",
    "id": null,
    "metadata": {},
    "name": "QGetHistoriesFramesQuery",
    "operationKind": "query",
    "text": "query QGetHistoriesFramesQuery(\n  $offerId: ID!\n  $bundleTag: String!\n  $version: String!\n  $nbOfFrame: String\n) {\n  getHistoryFrames(offerId: $offerId, bundleTag: $bundleTag, version: $version, nbOfFrame: $nbOfFrame) {\n    createdAt\n    externalId\n    metadata\n    id\n  }\n}\n"
  }
};
})();

node.hash = "30086325e97f71ec71a25d19a1efd04f";

export default node;
